import React from 'react'
import Drawer from '@material-ui/core/Drawer'
import ListItem from '@material-ui/core/ListItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import PlaylistAddCheckIcon from '@material-ui/icons/PlaylistAddCheck'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import './styles.css'
import PlaceIcon from '@material-ui/icons/Home'
import AccountCircle from '@material-ui/icons/AccountCircle'
import PowerSettingsNewIcon from '@material-ui/icons/PowerSettingsNew'
import SwitchLabel from '../SwitchLabel'
import { Image, Transformation, CloudinaryContext } from 'cloudinary-react'

const withDrawer = PageComponent => {
  const WrappedDrawerPageComponent = props => {
    const { authentication } = props
    const { authenticatedUser } = authentication
    const { first_name, last_name, avatar } = authenticatedUser

    const avatarID =
      typeof avatar === 'string' &&
      avatar.length > 0 &&
      JSON.parse(avatar) &&
      JSON.parse(avatar).public_id &&
      JSON.parse(avatar).public_id !== ''
        ? JSON.parse(avatar).public_id
        : ''

    const MenuListItems = (
      <div>
        <div className="drawerHeader">
          <div
            style={{
              height: '5vh'
            }}
          />

          <div className="drawerPhoto">
            {avatarID ? (
              <CloudinaryContext cloudName="safeshowings">
                <Image publicId={avatarID} format="png">
                  <Transformation
                    crop="fill"
                    gravity="faces"
                    width="50"
                    height="50"
                    radius="max"
                    border="1px_solid_white"
                  />
                </Image>
              </CloudinaryContext>
            ) : (
              <AccountCircle //here
                style={{
                  width: '100%',
                  height: '100%',
                  color: 'rgba(255,255,255,1)'
                }}
              />
            )}
          </div>
          {/* ////// */}
          <h4
            style={{
              paddingBottom: '0px',
              paddingTop: '0px',
              margin: '0px'
            }}
          >
            {first_name} {last_name}
          </h4>
          <h5
            style={{
              paddingBottom: '10px',
              paddingTop: '10px',
              margin: '0px'
            }}
          >
            {/* Charleston, SC */}
          </h5>
        </div>

        {/* LOGOUT */}
        <Link to="/register" className="router-link">
          <ListItem
            button
            onClick={() => {
              props.dispatch({ type: 'DRAWER_TOGGLED' })
              props.doLogout()
            }}
          >
            <ListItemIcon>
              <PowerSettingsNewIcon />
            </ListItemIcon>
            <ListItemText primary="Logout" />
          </ListItem>
        </Link>
      </div>
    )

    const onEmergencyClick = () => {
      props.dispatch({ type: 'DRAWER_TOGGLED', payload: false })
      props.dispatch({ type: 'PANIC_SNACKBAR' })
    }

    return (
      <div>
        <PageComponent {...props} />
        <Drawer open={props.open} onClose={props.toggleDrawer(props.open)}>
          <div tabIndex={0} role="button">
            {MenuListItems}
          </div>
          <div style={{ flexGrow: 1 }} />
          <button
            onContextMenu={e => {
              e.persist()
              e.preventDefault()
              return false
            }}
            onClick={onEmergencyClick}
            style={{ padding: '15px', cursor: 'pointer' }}
            className="long-press-button"
          >
            EMERGENCY
          </button>
        </Drawer>
      </div>
    )
  }

  const mapStateToProps = state => {
    return { open: state.drawer.open }
  }
  const mapActionsToProps = dispatch => {
    return {
      toggleDrawer: open => () => {
        dispatch({ type: 'DRAWER_TOGGLED' })
      },
      doLogout: () => {
        dispatch({ type: 'LOGOUT' })
        dispatch({ type: 'DRAWER_TOGGLED' })
        localStorage.clear()
      }
    }
  }

  const connector = connect(
    mapStateToProps,
    mapActionsToProps
  )

  return connector(WrappedDrawerPageComponent)
}

export default withDrawer
